import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

tippy('#consents', {
  content: 'The processing and administration of your data is carried out by Globe Group S.A. with its registered seat in Poland: 61-808 Poznań ul. Św Marcin 69. Please take a look at our <a href="../docs/GG_SA_Polityka_Prywatnosci.pdf" target="_blank">Privacy Policy</a> to see how we are processing your personal data. ',
  interactive: true,
  allowHTML: true,
});
